import React, { useEffect, useState } from "react";

export default function DelayedInput(props) {
  const [inputVal, setInputVal] = useState(""); 
  const [readyVal, setReadyVal] = useState(""); 
  const [delayTimer, setDelayTimer] = useState(null); 

  useEffect(() => {
    props.onFinished(readyVal);
  }, [readyVal]);

  useEffect(() => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }

    let t = setTimeout(() => {
      if (inputVal.length > props.minimum || !inputVal) {
        setReadyVal(inputVal);
      }
    }, props.delayms);

    setDelayTimer(t);
  }, [inputVal]);

  function handleChange(e) {
    e.preventDefault();
    setInputVal(e.target.value);
  }

  return React.cloneElement(props.children, {onChange: handleChange, value: inputVal});
}
